import { elegir } from '../ui/layout-variant.tsx';
import { IngestaMobile } from './Ingesta.mobile.tsx';
import { IngestaDesktop } from './Ingesta.desktop.tsx';

export default elegir(IngestaMobile, IngestaDesktop);
